import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpContext } from '@angular/common/http';
import { ThematicSubscription } from 'src/app/shared/interfaces/thematicsubscription.interface';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  private readonly urlCustomer = environment.customerUrl;
  private http = inject(HttpClient);
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() { }

  ThematicSubscription(thematic: ThematicSubscription, titanId: string) {
    const url = `${this.urlCustomer}/api/ThematicSubscription`
    return this.http.post<boolean>(url, thematic);
  }

}
